import React, { FC, useEffect, useState, MouseEvent, useCallback } from "react";
import classNames from "classnames/dedupe";
import { Button } from "../../ActionsSelectors/Button";
import { AddToCartIcon, CheckIcon } from "../../../icons";

export interface IAddToCartButtonProps {
  /**
   * Set if item in cart
   */
  isAddedToCart?: boolean;
  /**
   * Set if button in disabled
   */
  isDisabled?: boolean;
  /**
   * Callback function on when wishlisted status has changed
   */
  onClick?: (isAddedToCart: boolean) => void;
}

const AddToCartButton: FC<IAddToCartButtonProps> = ({
  isAddedToCart = false,
  isDisabled = false,
  onClick,
}) => {
  const [isAddedToCartState, setIsAddedToCart] =
    useState<boolean>(isAddedToCart);
  useEffect(() => {
    setIsAddedToCart(isAddedToCart);
  }, [isAddedToCart]);

  const handleIsAddedToCart = useCallback(
    (e: MouseEvent) => {
      isAddedToCart && setIsAddedToCart(true);
      onClick && onClick(true);
      e.preventDefault();
      e.stopPropagation();
    },
    [onClick, isAddedToCart],
  );

  const icon = isAddedToCartState ? (
    <CheckIcon data-testid="icon-add-to-cart-success" />
  ) : (
    <AddToCartIcon data-testid="icon-add-to-cart" />
  );

  const variant = isDisabled ? "iconDisabled" : "iconMedium";

  const styles = classNames("text-color-blue", { active: isAddedToCartState });

  return (
    <Button
      variant={variant}
      onClick={handleIsAddedToCart}
      data-testid="AddToCart__TestID"
      classes={{ root: styles }}
      disabled={isDisabled}
    >
      {icon}
    </Button>
  );
};

export default AddToCartButton;
